"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var mobx_react_1 = require("mobx-react");
var mui_1 = require("tss-react/mui");
// locals
var configuration_1 = require("../configuration");
var util_1 = require("../util");
var useStyles = (0, mui_1.makeStyles)()({
  importFormEntry: {
    minWidth: 180
  }
});
var AssemblySelector = (0, mobx_react_1.observer)(function (_ref) {
  var session = _ref.session,
    onChange = _ref.onChange,
    selected = _ref.selected,
    InputProps = _ref.InputProps,
    TextFieldProps = _ref.TextFieldProps,
    localStorageKey = _ref.localStorageKey,
    _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? 'Select assembly to view' : _ref$helperText;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var assemblyNames = session.assemblyNames,
    assemblyManager = session.assemblyManager; // constructs a localstorage key based on host/path/config to help
  // remember. non-config assists usage with e.g. embedded apps
  var config = new URLSearchParams(window.location.search).get('config');
  var _ref2 = typeof jest === 'undefined' && localStorageKey ? (0, util_1.useLocalStorage)("lastAssembly-".concat([window.location.host + window.location.pathname, config, localStorageKey].join('-')), selected) : (0, react_1.useState)(selected),
    _ref3 = _slicedToArray(_ref2, 2),
    lastSelected = _ref3[0],
    setLastSelected = _ref3[1];
  var selection = assemblyNames.includes(lastSelected || '') ? lastSelected : selected;
  (0, react_1.useEffect)(function () {
    if (selection && selection !== selected) {
      onChange(selection);
    }
  }, [selection, onChange, selected]);
  var error = assemblyNames.length ? '' : 'No configured assemblies';
  return react_1.default.createElement(material_1.TextField, _objectSpread({
    select: true,
    label: "Assembly",
    variant: "outlined",
    helperText: error || helperText,
    value: selection || '',
    inputProps: {
      'data-testid': 'assembly-selector'
    },
    onChange: function onChange(event) {
      return setLastSelected(event.target.value);
    },
    error: !!error,
    InputProps: InputProps,
    disabled: !!error,
    className: classes.importFormEntry
  }, TextFieldProps), assemblyNames.map(function (name) {
    var assembly = assemblyManager.get(name);
    var displayName = assembly ? (0, configuration_1.getConf)(assembly, 'displayName') : '';
    return react_1.default.createElement(material_1.MenuItem, {
      key: name,
      value: name
    }, displayName || name);
  }));
});
exports.default = AssemblySelector;